<template>
    <el-dialog top="10px" title="图片生成" :visible.sync="isVisible" width="80%"  :close-on-click-modal="false" :close-on-press-escape="false" :fullscreen="false" :append-to-body="true">

    <el-form autocomplete="off" ref="operationForm" :model="operationForm" :rules="formRules" label-position="top"
               style="">

        <el-row :gutter="60">
          <el-col :span="8" :xs="24" :md="8">

            <el-form-item prop="title" label="提示词">
              <el-button type="text" size="small" @click="aiCreate">AI写提示词</el-button>
              <el-input type="textarea" :autosize="{minRows: 4,maxRows: 4}" v-model="operationForm.prompt" size="large"
                        clearable
                        placeholder="请输入"
                        autocomplete="off"></el-input>
            </el-form-item>
            <text-generate ref="TextGenerate" @refresh="fillPrompt"></text-generate>

            <el-form-item prop="style" label="场景风格">

              <el-select v-model="operationForm.style" size="large">
                <el-option v-for="item in styles" :value="item.value" :key="item.name" :label="item.name"></el-option>
              </el-select>
            </el-form-item>


            <el-form-item prop="num" label="生成张数">
              <el-radio-group v-model="operationForm.num">
                <el-radio label="1">1张</el-radio>
                <el-radio label="2">2张</el-radio>
                <el-radio label="3">3张</el-radio>
                <el-radio label="4">4张</el-radio>
              </el-radio-group>
            </el-form-item>


            <el-form-item prop="aspectRadio" label="生成比例（宽:高）">
              <el-select v-model="operationForm.size" size="large">
                <el-option v-for="item in sizeList" :value="item" :key="item">{{ item }}</el-option>
              </el-select>
            </el-form-item>

            <el-button :disabled="btnDisable" long class="btn" style="width: 100%;" size="large" @click="handleConfirm">
              生成图片
            </el-button>


          </el-col>


          <el-col :span="14" :xs="24" :md="14">

            <loading ref="loading"></loading>

            <div class="attach-item" v-for="(item,index) in images">
              <img style="border-radius: 20px" :src="item" width="100%">
              <el-button size="small" type="text" icon="el-icon-delete" @click="pickItem(item)">确定使用</el-button>
            </div>

          </el-col>


        </el-row>


      </el-form>

    </el-dialog>

</template>

<script>

import Loading from "@/components/Loading"

export default {
  data() {
    const t = this
    return {

      btnDisable: false,


      sizeList: ["1024*1024", "720*1280", "1280*720"],
      styles: [
        {name: '默认', value: 'auto'},
        {name: '摄影', value: 'photography'},
        {name: '人像写真', value: 'portrait'},
        {name: '3D卡通', value: '3d cartoon'},

        {name: '动画', value: 'anime'},
        {name: '油画', value: 'oil painting'},
        {name: '水彩', value: 'watercolor'},
        {name: '素描', value: 'sketch'},
        {name: '中国画', value: 'chinese painting'},
        {name: '扁平插画', value: 'flat illustration'},
      ],

      images: [],
      operationForm: {
        baseImage: '',
        num: '1',
        prompt: '',
        size: '1024*1024',
        style: 'auto',

      },

      formRules: {},
      isVisible:false

    }
  },
  components: {Loading},
  methods: {

    show(){
      this.isVisible = true;
      this.images = []
    },

    aiCreate() {
      if (!this.operationForm.prompt) {
        this.$message('请填入简短提示词后再使用AI生成')
        return
      }
      this.$refs.TextGenerate.show("写一段图片生成提示词 " + this.operationForm.prompt + " 直接返回结果")
    },
    fillPrompt(e) {
      this.operationForm.prompt = e;
    },

    pickItem(e){
      this.isVisible = false;
      this.$emit('refresh',e);
    },
    handleConfirm() {

      let token = localStorage.getItem("token");
      if (!token) {
        this.$emit("checkLogin");
        return;
      }

      const t = this;
      t.images = [];

      this.$refs.loading.show()
      this.btnDisable = true;

      this.$post(
        {
          context: t,
          loading: false,
          path: '/aigc/image/image_common_create/',
          params: {
            ref_image_url: t.operationForm.baseImage,
            prompt: t.operationForm.prompt,
            num: t.operationForm.num,
            size: t.operationForm.size || '',
            style: t.operationForm.style || '',
            scene: 1
          },
          success: function (data) {
            t.images = data.images;
            t.$refs.loading.dismiss()
            t.btnDisable = false;
          },
          error: function () {
            t.$refs.loading.dismiss()
            t.btnDisable = false;
          }
        }
      )
    },


  }
}
</script>

<style scoped >
@import '../assets/global.css';
.attach-container {
  display: flex;
  flex-wrap: wrap; /* 关键属性：允许自动换行 */
  gap: 10px; /* 可选：设置项目之间的间距 */
}

.attach-item {
  flex: 1 1 auto; /* 项目可以伸缩 */
  min-width: 180px; /* 设置最小宽度，防止项目过小 */
  max-width: 180px;
  padding: 10px;
  box-sizing: border-box;
  text-align: center;
}
</style>

